module.exports = __webpack_public_path__ + "img/mongodb.298c7c8b.svg";